import { create } from "zustand";
import { persist } from "zustand/middleware";
import type { Language } from "@/types";

interface LocaleState {
  language: Language;
  setLanguage: (lang: Language) => void;
}

export const useLocaleStore = create<LocaleState>()(
  persist(
    (set) => ({
      language: "en",
      setLanguage: (language) => set({ language }),
    }),
    {
      name: "kiborg-locale",
    }
  )
);
